import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";
import { workflowScriptName } from "./workflow-script-name";

export function describeWorkflow(
  record: Record<string, unknown>,
): ToolActivity {
  const name = workflowScriptName(toolInput.str(record.script) ?? "");
  return labelOnly(name ? `Ran workflow "${name}"` : "Ran a workflow");
}
